const EducationSalary = ({locationStatistics}) => {
    return (
        <>
            {locationStatistics.isDisplayableEducationSalary &&
                <div className="p-knowledge_content p-knowledge_list_wrap">
                    <p className="p-knowledge_title">Median Annual Earnings by Last Level of Education</p>
                    <ul className="p-knowledge_list">
                        <li className="p-knowledge_list_item">Less than high school graduate: ${locationStatistics.knowledgePanelStatistics?.educationSalaryLessThanHighSchool}</li>
                        <li className="p-knowledge_list_item">High school graduate (including equivalent
                            education): ${locationStatistics.knowledgePanelStatistics.educationSalaryHighSchoolGraduate}
                        </li>
                        <li className="p-knowledge_list_item">Junior college graduate or associate degree:
                            ${locationStatistics.knowledgePanelStatistics?.educationSalaryAssociate}
                        </li>
                        <li className="p-knowledge_list_item">Bachelor's degree: ${locationStatistics.knowledgePanelStatistics?.educationSalaryBachelor}</li>
                        <li className="p-knowledge_list_item">Postgraduate or professional degree: ${locationStatistics.knowledgePanelStatistics?.educationSalaryGraduate}</li>
                    </ul>
                </div>
            }
        </>
    )
}

export default EducationSalary;
